import Vue from 'vue'
import { fetchMapById, fetchMapVideos, fetchMapStats, fetchMapMarkers } from '@/api/csgo'

const state = () => ({
  maps: []
})

const mutations = {
  'SET_MAPS': (state, payload) => {
    Vue.set(state, 'maps', payload)
  },
  'SET_CURRENT_MAP': (state, payload) => {
    Vue.set(state, 'currentMap', payload)
  },
  'UPDATE_OR_ADD_MAP': (state, payload) => {
    let map = state.maps.find((obj) => {
      return obj.id === payload.id
    })
    if (map) {
      let index = state.maps.indexOf(map)
      state.maps[index] = payload
    } else {
      state.maps.push(payload)
      Vue.set(state, 'maps', state.maps)
    }
  },
  'SET_MAP_VIDEOS': (state, payload) => {
    let map = state.maps.find((obj) => {
      return obj.id === payload.id
    })

    let index = state.maps.indexOf(map)
    Vue.set(state.maps[index], 'videos', payload.videos)
  },
  'SET_MAP_STATS': (state, payload) => {
    let map = state.maps.find((obj) => {
      return obj.id === payload.id
    })

    let index = state.maps.indexOf(map)
    Vue.set(state.maps[index], 'stats', payload.stats)
  },
  'SET_MAP_MARKERS': (state, payload) => {
    let map = state.maps.find((obj) => {
      return obj.id === payload.id
    })

    let index = state.maps.indexOf(map)
    Vue.set(state.maps[index], 'markers', payload.markers)
  },
}

const actions = {
  setMaps ({commit}, payload) {
    commit('SET_MAPS', payload)
  },
  fetchMapData ({commit, getters, dispatch}, key) {
    let map = getters.getMapByProp({prop: 'id', value: key})

    if (key === 0) {
      return dispatch('fetchAllMapData', key)
    }

    let getMapOrFetch = new Promise((resolve, reject) => {
      if (!map) {
        fetchMapById(key).then((data) => {
          commit('UPDATE_OR_ADD_MAP', data)
          resolve(data)
        }).catch((error) => {
          window.location = '/404'
          reject(error)
        })
      } else {
        resolve(map)
      }
    })

    return getMapOrFetch.then((map) => {
      if (map) {
        let mapId = map.id
        let videoPromise = new Promise((resolve, reject) => {
          fetchMapVideos(mapId).then((data) => {
            commit('SET_MAP_VIDEOS', {id: mapId, videos: data})
            resolve(data)
          }).catch((error) => {
            commit('SET_MAP_VIDEOS', {id: mapId, videos: null})
            resolve(error)
          })
        })

        let statsPromise = new Promise((resolve, reject) => {
          fetchMapStats(mapId).then((data) => {
            commit('SET_MAP_STATS', {id: mapId, stats: data})
            resolve(data)
          }).catch((error) => {
            commit('SET_MAP_STATS', {id: mapId, stats: null})
            resolve(error)
          })
        })

        let markerPromise = new Promise((resolve, reject) => {
          fetchMapMarkers(mapId).then((data) => {
            // convert map markers to correct format
            let mappedMarkers = data.map((obj) => {
              let team = ''
              let type = ''
              let typeSplits = obj.type.split('-')
              if (typeSplits.length === 2) {
                team = typeSplits[1].toLowerCase()
              } else {
                team = 'both'
              }
              type = typeSplits[0].toLowerCase()

              return {
                x: obj.x,
                y: obj.y,
                team: team,
                type: type,
                guide: obj.guide
              }
            })

            commit('SET_MAP_MARKERS', {id: mapId, markers: mappedMarkers})
            resolve(data)
          }).catch((error) => {
            commit('SET_MAP_MARKERS', {id: mapId, markers: null})
            resolve(error)
          })
        })

        return Promise.all([videoPromise, statsPromise, markerPromise])
      }
    }).catch((error) => {
      console.log(error)
    })
  },
  updateOrAddMap ({commit}, payload) {
    commit('UPDATE_OR_ADD_MAP', payload)
  },
  setMapVideos ({commit}, payload) {
    commit('SET_MAP_VIDEOS', payload)
  },
  setMapStats ({commit}, payload) {
    commit('SET_MAP_STATS', payload)
  }
}

const getters = {
  getMaps: state => { return state.maps },
  getActiveMaps: state => {
    return state.maps.filter((obj) => {
      return obj.in_active_duty === "1"
    })
  },
  getMap: state => key => {
    return state.maps.find((obj) => {
      return obj.key === key
    })
  },
  getMapByProp: state => payload => {
    return state.maps.find((obj) => {
      return (obj[payload.prop].toString() === payload.value.toString())
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/maps.js